<template>
  <div>
    <v-select
      :dir="dir"
      :rules="rules"
      :label="label"
      v-model="innerValue"
      variant="outlined"
      hide-details="auto"
      :hint="hint"
      :items="options"
      item-title="option"
      item-value="option_id"
      :multiple="isMultiple"
      :readonly="readOnly"
    />
  </div>
</template>

<script>
export default {
  name: "SelectInput",

  props: {
    modelValue: {
      type: [String, Number, Array],
      default: null
    },
    label: String,
    hint: String,
    isRequired: Boolean,
    isSearchable: Boolean,
    isMultiple: Boolean,
    options: {
      type: Array,
      default: () => []
    },
    dir: String,
    readOnly: Boolean
  },

  data() {
    return {
      innerValue: this.modelValue
    }
  },

  computed: {
    rules() {
      return this.isRequired ? [(value) => !!value || "الزامی"] : []
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>
